exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ReactModal__Content{min-width:480px;background-color:#e8e9eb!important}@media (max-width:500px){.ReactModal__Content{min-width:330px}}.ReactModal__Overlay{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(50,66,88,.8);z-index:100}.ReactModal__Content{position:absolute;top:50%;left:50%;width:270px;border:none;outline:none;border-radius:12px;padding:0;transform:translate(-50%,-50%);background-color:#fff;font-size:1.3rem}.session-types-modal{width:auto}h4,p{text-align:center;margin-bottom:5px}h4{font-size:16px}input{height:26px;font-size:1.3rem;padding-top:0;padding-bottom:0}.modal-btns{display:flex;border-top:1px solid gray}.ReactModal__Content .btn{padding:1.2rem .5rem;flex-grow:1;width:50%;font-size:1.8rem;font-weight:400}.ReactModal__Content .btn:first-child{border-right:1px solid gray;border-radius:0 0 0 12px;color:gray}.ReactModal__Content .btn:last-child{border-radius:0 0 12px}.ReactModal__Content img{margin-top:6px;margin-left:4px}.ReactModal__Content .main-btn{background-color:#467093}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/modules/profile/components/cardForm.css
// module id = 678
// module chunks = 0